import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import VerticalLine from "./vertical-dots.svg?react";
import DimensionalDifferenceTwoColumnContainer from "components/ddiff-containers/ddiff-two-column-container/DimensionalDifferenceTwoColumnContainer";
import AnimatedExhibitInfographicHeadline from "components/ddiff-animated-exhibit/AnimatedExhibitInfoHeadline";
import {
	isMobile,
	isTablet,
	isDesktop,
	isContentMax
} from "components/utility/page-responsive/PageResponsive";
import { DToolTipAdapterContainer } from "components/ui-platform";
import { getDecodedHtml } from "utils/getDecodedHtml";

const OutperformedAnimatedExhibit = ({ data }) => {
	const { charts, headline, infographicHeadline, hoverContent, disclosure } = data;

	const coloredChart = useRef(null);
	const chartSection = useRef(null);
	const firstLabel = useRef(null);
	const secondLabel = useRef(null);
	const secondChartFirstLabel = useRef(null);
	const secondChartSecondLabel = useRef(null);
	const thirdChartFirstLabel = useRef(null);
	const thirdChartSecondLabel = useRef(null);
	const fourthChartFirstLabel = useRef(null);
	const fourthChartSecondLabel = useRef(null);
	const secondDots = useRef(null);
	const [labelsReadyToMove, setLabelsReadyToMove] = useState(false);
	const [isIntersecting, setIsIntersecting] = useState(false);
	const [firstLabelpos, setFirstLabelpos] = useState("4rem");
	const [secondLabelpos, setSecondLabelpos] = useState("3rem");
	const [chartOpacity, setChartOpacity] = useState(false);
	const [headlineAnimation, setHeadlineAnimation] = useState(false);
	const [bgChartWidth, setBgChartWidth] = useState(false);
	const [verticalLineLocation, setVerticalLineLocation] = useState(false);
	const [colorChartOpacity, setColorChartOpacity] = useState(false);
	const [secondChart, setSecondChart] = useState(false);
	const [firstDotsRun, setFirstDotsRun] = useState(false);
	const [isMobileScreen, setIsMobile] = useState(false);
	// Controls the initial width of gray bars
	// Controls the end width of the color bars
	// Controls the location of the dots and where they start
	const [colorWidth, setColorWidthArr] = useState({
		chartOne: {
			itemOne: {
				width: "0rem",
				left: "40rem"
			},
			itemTwo: {
				width: "0rem",
				left: "40rem"
			}
		},
		chartTwo: {
			itemOne: {
				width: "0rem",
				left: "40rem"
			},
			itemTwo: {
				width: "0rem",
				left: "40rem"
			}
		},
		chartThree: {
			itemOne: {
				width: "0rem",
				left: "0rem"
			},
			itemTwo: {
				width: "0rem",
				left: "0rem"
			}
		},
		chartFour: {
			itemOne: {
				width: "0rem",
				left: "0rem"
			},
			itemTwo: {
				width: "0rem",
				left: "0rem"
			}
		}
	});

	useEffect(() => {
		if (isContentMax()) {
			setColorWidthArr((prevWidth) => ({
				...prevWidth,
				chartOne: {
					itemOne: {
						width: "0rem",
						left: "37.9375rem"
					},
					itemTwo: {
						width: "0rem",
						left: "37.9375rem"
					}
				},
				chartTwo: {
					itemOne: {
						width: "0rem",
						left: "37.9375rem"
					},
					itemTwo: {
						width: "0rem",
						left: "37.9375rem"
					}
				},
				chartThree: {
					itemOne: {
						width: "0rem",
						left: "0rem"
					},
					itemTwo: {
						width: "0rem",
						left: "0rem"
					}
				},
				chartFour: {
					itemOne: {
						width: "0rem",
						left: "0rem"
					},
					itemTwo: {
						width: "0rem",
						left: "0rem"
					}
				}
			}));
		} else if (isDesktop()) {
			setColorWidthArr((prevWidth) => ({
				...prevWidth,
				chartOne: {
					itemOne: {
						width: "0rem",
						left: "39.25rem"
					},
					itemTwo: {
						width: "0rem",
						left: "39.25rem"
					}
				},
				chartTwo: {
					itemOne: {
						width: "0rem",
						left: "39.25rem"
					},
					itemTwo: {
						width: "0rem",
						left: "39.25rem"
					}
				},
				chartThree: {
					itemOne: {
						width: "0rem",
						left: "0rem"
					},
					itemTwo: {
						width: "0rem",
						left: "0rem"
					}
				},
				chartFour: {
					itemOne: {
						width: "0rem",
						left: "0rem"
					},
					itemTwo: {
						width: "0rem",
						left: "0rem"
					}
				}
			}));
		} else if (isTablet) {
			setColorWidthArr((prevWidth) => ({
				...prevWidth,
				chartOne: {
					itemOne: {
						width: "0rem",
						left: "40rem"
					},
					itemTwo: {
						width: "0rem",
						left: "40rem"
					}
				},
				chartTwo: {
					itemOne: {
						width: "0rem",
						left: "40rem"
					},
					itemTwo: {
						width: "0rem",
						left: "40rem"
					}
				},
				chartThree: {
					itemOne: {
						width: "0rem",
						left: "0rem"
					},
					itemTwo: {
						width: "0rem",
						left: "0rem"
					}
				},
				chartFour: {
					itemOne: {
						width: "0rem",
						left: "0rem"
					},
					itemTwo: {
						width: "0rem",
						left: "0rem"
					}
				}
			}));
		}
	}, []);

	const triggerFirstDots = () => {
		setFirstDotsRun(true);
	};

	const triggerHeadlineAnimation = () => {
		setHeadlineAnimation(true);
	};
	const triggerFirstChartAnimation = () => {
		setChartOpacity(true);
		setBgChartWidth(true);
		setVerticalLineLocation(true);
	};
	const triggerColorChartOpacity = () => {
		setColorChartOpacity(true);
		setSecondChart(true);
	};

	const convertToDecimal = (percent, total, item) => {
		let percentage = parseFloat(percent) / 100;
		let labelPercentage = percentage * total;
		if (item) {
			// 0.1 is arbitrary value so that the dots can be hald off edge of the color chart
			labelPercentage = labelPercentage - 0.1;
			let labelString = `${labelPercentage}rem`;
			return labelString;
		} else {
			let labelString = `${labelPercentage}rem`;
			return labelString;
		}
	};

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				setIsIntersecting(entry.isIntersecting);
			},
			{
				rootMargin: "0px 0px -25% 0px"
			}
		);
		if (chartSection.current !== null) {
			observer.observe(chartSection.current);
		}

		return () => observer.disconnect();
	}, []);

	useEffect(() => {
		if (isIntersecting) {
			triggerHeadlineAnimation();
		}
	}, [isIntersecting]);

	useEffect(() => {
		const isMobileFunc = () => {
			if (isMobile()) {
				setSecondChart(true);
				setFirstDotsRun(true);
				setBgChartWidth(true);
				return setIsMobile(true);
			}
			setIsMobile(false);
		};
		isMobileFunc();
		window.addEventListener("resize", isMobileFunc);

		return () => {
			window.removeEventListener("resize", isMobileFunc);
		};
	}, []);

	useEffect(() => {
		// size in rems of all bars at each breakpoint so it knows the full width of gray bar to expand
		const grayBarInitialLength = {
			lg: 37.9375,
			md: 39.25,
			sm: 40,
			xs: 19.5
		};

		if (verticalLineLocation || isMobileScreen) {
			const firstLabelItem = firstLabel.current.offsetWidth / 2 / 16;
			const secondLabelItem = secondLabel.current.clientWidth / 2 / 16;

			setFirstLabelpos(`-${firstLabelItem}rem`);
			setSecondLabelpos(`-${secondLabelItem}rem`);

			coloredChart.current.addEventListener("transitionend", triggerColorChartOpacity);

			const windowSize = () => {
				if (charts.length > 0) {
					if (window.innerWidth >= 1440) {
						setColorWidthArr((prevWidth) => ({
							...prevWidth,
							chartOne: {
								itemOne: {
									width: convertToDecimal(
										charts[0].stocks[0].stockValues[0].value,
										grayBarInitialLength.lg
									),
									left: convertToDecimal(
										charts[0].stocks[0].stockValues[0].value,
										grayBarInitialLength.lg,
										"left"
									)
								},
								itemTwo: {
									width: convertToDecimal(
										charts[0].stocks[0].stockValues[1].value,
										grayBarInitialLength.lg
									),
									left: convertToDecimal(
										charts[0].stocks[0].stockValues[1].value,
										grayBarInitialLength.lg,
										"left"
									)
								}
							},
							chartTwo: {
								itemOne: {
									width: convertToDecimal(
										charts[0].stocks[1].stockValues[0].value,
										grayBarInitialLength.lg
									),
									left: convertToDecimal(
										charts[0].stocks[1].stockValues[0].value,
										grayBarInitialLength.lg,
										"left"
									)
								},
								itemTwo: {
									width: convertToDecimal(
										charts[0].stocks[1].stockValues[1].value,
										grayBarInitialLength.lg
									),
									left: convertToDecimal(
										charts[0].stocks[1].stockValues[1].value,
										grayBarInitialLength.lg,
										"left"
									)
								}
							},
							chartThree: {
								itemOne: {
									width: convertToDecimal(
										charts[1].stocks[0].stockValues[0].value,
										grayBarInitialLength.lg
									),
									left: convertToDecimal(
										charts[1].stocks[0].stockValues[0].value,
										grayBarInitialLength.lg,
										"left"
									)
								},
								itemTwo: {
									width: convertToDecimal(
										charts[1].stocks[0].stockValues[1].value,
										grayBarInitialLength.lg
									),
									left: convertToDecimal(
										charts[1].stocks[0].stockValues[1].value,
										grayBarInitialLength.lg,
										"left"
									)
								}
							},
							chartFour: {
								itemOne: {
									width: convertToDecimal(
										charts[1].stocks[1].stockValues[0].value,
										grayBarInitialLength.lg
									),
									left: convertToDecimal(
										charts[1].stocks[1].stockValues[0].value,
										grayBarInitialLength.lg,
										"left"
									)
								},
								itemTwo: {
									width: convertToDecimal(
										charts[1].stocks[1].stockValues[1].value,
										grayBarInitialLength.lg
									),
									left: convertToDecimal(
										charts[1].stocks[1].stockValues[1].value,
										grayBarInitialLength.lg,
										"left"
									)
								}
							}
						}));
					} else if (window.innerWidth < 1440 && window.innerWidth > 1024) {
						setColorWidthArr((prevWidth) => ({
							...prevWidth,
							chartOne: {
								itemOne: {
									width: convertToDecimal(
										charts[0].stocks[0].stockValues[0].value,
										grayBarInitialLength.md
									),
									left: convertToDecimal(
										charts[0].stocks[0].stockValues[0].value,
										grayBarInitialLength.md,
										"left"
									)
								},
								itemTwo: {
									width: convertToDecimal(
										charts[0].stocks[0].stockValues[1].value,
										grayBarInitialLength.md
									),
									left: convertToDecimal(
										charts[0].stocks[0].stockValues[1].value,
										grayBarInitialLength.md,
										"left"
									)
								}
							},
							chartTwo: {
								itemOne: {
									width: convertToDecimal(
										charts[0].stocks[1].stockValues[0].value,
										grayBarInitialLength.md
									),
									left: convertToDecimal(
										charts[0].stocks[1].stockValues[0].value,
										grayBarInitialLength.md,
										"left"
									)
								},
								itemTwo: {
									width: convertToDecimal(
										charts[0].stocks[1].stockValues[1].value,
										grayBarInitialLength.md
									),
									left: convertToDecimal(
										charts[0].stocks[1].stockValues[1].value,
										grayBarInitialLength.md,
										"left"
									)
								}
							},
							chartThree: {
								itemOne: {
									width: convertToDecimal(
										charts[1].stocks[0].stockValues[0].value,
										grayBarInitialLength.md
									),
									left: convertToDecimal(
										charts[1].stocks[0].stockValues[0].value,
										grayBarInitialLength.md,
										"left"
									)
								},
								itemTwo: {
									width: convertToDecimal(
										charts[1].stocks[0].stockValues[1].value,
										grayBarInitialLength.md
									),
									left: convertToDecimal(
										charts[1].stocks[0].stockValues[1].value,
										grayBarInitialLength.md,
										"left"
									)
								}
							},
							chartFour: {
								itemOne: {
									width: convertToDecimal(
										charts[1].stocks[1].stockValues[0].value,
										grayBarInitialLength.md
									),
									left: convertToDecimal(
										charts[1].stocks[1].stockValues[0].value,
										grayBarInitialLength.md,
										"left"
									)
								},
								itemTwo: {
									width: convertToDecimal(
										charts[1].stocks[1].stockValues[1].value,
										grayBarInitialLength.md
									),
									left: convertToDecimal(
										charts[1].stocks[1].stockValues[1].value,
										grayBarInitialLength.md,
										"left"
									)
								}
							}
						}));
					} else if (window.innerWidth <= 1024 && window.innerWidth >= 768) {
						setColorWidthArr((prevWidth) => ({
							...prevWidth,
							chartOne: {
								itemOne: {
									width: convertToDecimal(
										charts[0].stocks[0].stockValues[0].value,
										grayBarInitialLength.sm
									),
									left: convertToDecimal(
										charts[0].stocks[0].stockValues[0].value,
										grayBarInitialLength.sm,
										"left"
									)
								},
								itemTwo: {
									width: convertToDecimal(
										charts[0].stocks[0].stockValues[1].value,
										grayBarInitialLength.sm
									),
									left: convertToDecimal(
										charts[0].stocks[0].stockValues[1].value,
										grayBarInitialLength.sm,
										"left"
									)
								}
							},
							chartTwo: {
								itemOne: {
									width: convertToDecimal(
										charts[0].stocks[1].stockValues[0].value,
										grayBarInitialLength.sm
									),
									left: convertToDecimal(
										charts[0].stocks[1].stockValues[0].value,
										grayBarInitialLength.sm,
										"left"
									)
								},
								itemTwo: {
									width: convertToDecimal(
										charts[0].stocks[1].stockValues[1].value,
										grayBarInitialLength.sm
									),
									left: convertToDecimal(
										charts[0].stocks[1].stockValues[1].value,
										grayBarInitialLength.sm,
										"left"
									)
								}
							},
							chartThree: {
								itemOne: {
									width: convertToDecimal(
										charts[1].stocks[0].stockValues[0].value,
										grayBarInitialLength.sm
									),
									left: convertToDecimal(
										charts[1].stocks[0].stockValues[0].value,
										grayBarInitialLength.sm,
										"left"
									)
								},
								itemTwo: {
									width: convertToDecimal(
										charts[1].stocks[0].stockValues[1].value,
										grayBarInitialLength.sm
									),
									left: convertToDecimal(
										charts[1].stocks[0].stockValues[1].value,
										grayBarInitialLength.sm,
										"left"
									)
								}
							},
							chartFour: {
								itemOne: {
									width: convertToDecimal(
										charts[1].stocks[1].stockValues[0].value,
										grayBarInitialLength.sm
									),
									left: convertToDecimal(
										charts[1].stocks[1].stockValues[0].value,
										grayBarInitialLength.sm,
										"left"
									)
								},
								itemTwo: {
									width: convertToDecimal(
										charts[1].stocks[1].stockValues[1].value,
										grayBarInitialLength.sm
									),
									left: convertToDecimal(
										charts[1].stocks[1].stockValues[1].value,
										grayBarInitialLength.sm,
										"left"
									)
								}
							}
						}));
					} else if (window.innerWidth < 768) {
						setColorWidthArr((prevWidth) => ({
							...prevWidth,
							chartOne: {
								itemOne: {
									width: convertToDecimal(
										charts[0].stocks[0].stockValues[0].value,
										grayBarInitialLength.xs
									),
									left: convertToDecimal(
										charts[0].stocks[0].stockValues[0].value,
										grayBarInitialLength.xs,
										"left"
									)
								},
								itemTwo: {
									width: convertToDecimal(
										charts[0].stocks[0].stockValues[1].value,
										grayBarInitialLength.xs
									),
									left: convertToDecimal(
										charts[0].stocks[0].stockValues[1].value,
										grayBarInitialLength.xs,
										"left"
									)
								}
							},
							chartTwo: {
								itemOne: {
									width: convertToDecimal(
										charts[0].stocks[1].stockValues[0].value,
										grayBarInitialLength.xs
									),
									left: convertToDecimal(
										charts[0].stocks[1].stockValues[0].value,
										grayBarInitialLength.xs,
										"left"
									)
								},
								itemTwo: {
									width: convertToDecimal(
										charts[0].stocks[1].stockValues[1].value,
										grayBarInitialLength.xs
									),
									left: convertToDecimal(
										charts[0].stocks[1].stockValues[1].value,
										grayBarInitialLength.xs,
										"left"
									)
								}
							},
							chartThree: {
								itemOne: {
									width: convertToDecimal(
										charts[1].stocks[0].stockValues[0].value,
										grayBarInitialLength.xs
									),
									left: convertToDecimal(
										charts[1].stocks[0].stockValues[0].value,
										grayBarInitialLength.xs,
										"left"
									)
								},
								itemTwo: {
									width: convertToDecimal(
										charts[1].stocks[0].stockValues[1].value,
										grayBarInitialLength.xs
									),
									left: convertToDecimal(
										charts[1].stocks[0].stockValues[1].value,
										grayBarInitialLength.xs,
										"left"
									)
								}
							},
							chartFour: {
								itemOne: {
									width: convertToDecimal(
										charts[1].stocks[1].stockValues[0].value,
										grayBarInitialLength.xs
									),
									left: convertToDecimal(
										charts[1].stocks[1].stockValues[0].value,
										grayBarInitialLength.xs,
										"left"
									)
								},
								itemTwo: {
									width: convertToDecimal(
										charts[1].stocks[1].stockValues[1].value,
										grayBarInitialLength.xs
									),
									left: convertToDecimal(
										charts[1].stocks[1].stockValues[1].value,
										grayBarInitialLength.xs,
										"left"
									)
								}
							}
						}));
						setLabelsReadyToMove(true);
					}
				}
			};
			windowSize();
			window.addEventListener("resize", windowSize);
			return () => {
				window.removeEventListener("resize", windowSize);
			};
		}
	}, [charts, isMobileScreen, verticalLineLocation]);

	useLayoutEffect(() => {
		const fixCollidingLabels = (chartLabels) => {
			for (const chart in chartLabels) {
				const { outperformed, survived } = chartLabels[chart];
				if (outperformed && survived) {
					// Grab bounding boxes to compare positions on screen
					const outperformedBoundingBox = outperformed.getBoundingClientRect();
					const survivedBoundingBox = survived.getBoundingClientRect();

					// Design currently wants at least 16px between the outperformed and survived lables, adjust accordingly
					const minDistanceBetweenLabels = 16;
					// Design currently wants 16px between the dotted line and the label. 2px added to account for dotted line width
					const minDistanceBetweenDottedLineandLabel = 20;

					// If the outperformed is inside or less than 16px from the edge of the survived label we need to seperate them
					if (survivedBoundingBox.left < outperformedBoundingBox.right + minDistanceBetweenLabels) {
						let newSVGWidth;
						const survivedParentContainerBoundingBox = survived.parentNode.getBoundingClientRect();
						const percentageLabelBoundingBox = survived
							.querySelector(".ddiff-outperformed-chart-graph-labels-numbers")
							.getBoundingClientRect();

						// This gives us the space between the edge of the outperformed and the edge of survived
						const distanceBetweenLabels =
							survivedParentContainerBoundingBox.left - outperformedBoundingBox.right;

						const dottedLine = survived.parentNode.querySelector("svg");

						// As of writing, 34px is the default height of the dotted lines. If that changes, update this.
						const originalDottedLineHeight = 34;

						// Need to remove viewbox to avoid scaling the svg causing different sized circles from everything else
						dottedLine.removeAttribute("viewBox");

						// The styling changes at mobile, this lets us reset the align-items property to avoid funky ui
						if (isMobileScreen) {
							survived.style.alignItems = "start";
						} else {
							survived.style.removeProperty("align-items");
						}

						/*
                            When there is less than 16px of space between the labels, the magrin left is 16px off the label.
                            However, when the two labels collide furhter, the survived label will be 16px to the right of the outperformed label
                        */
						if (distanceBetweenLabels >= 0) {
							newSVGWidth = minDistanceBetweenDottedLineandLabel;
							survived.style.marginLeft = minDistanceBetweenDottedLineandLabel / 16 + "rem";
						} else {
							const distanceNeededToClearLabel = -distanceBetweenLabels + minDistanceBetweenLabels;
							survived.style.marginLeft = distanceNeededToClearLabel / 16 + "rem";
							newSVGWidth = distanceNeededToClearLabel;
						}

						// This adjusts the height of the dotted line to draw it to the middle of the number of the label, adds 2 to not cut off svg
						const newSVGHeight =
							2 + originalDottedLineHeight + percentageLabelBoundingBox.height / 2;

						// Styles the dotted line and sets a new path "d" to create the right angle dotted line
						dottedLine.style.height = newSVGHeight + "px";
						dottedLine.style.width = newSVGWidth + "px";
						dottedLine
							.querySelector("path")
							.setAttribute(
								"d",
								`M1 1L1 ${newSVGHeight} M1 ${newSVGHeight - 3} L${newSVGWidth - 4} ${
									newSVGHeight - 3
								}`
							);

						dottedLine.style.position = "absolute";

						// Remove margin on parent container causing dotted line to be pushed down
						dottedLine.parentNode.style.margin = "0";

						// Move the surved label down to were it originally was before making the dotted line absolute, collapsing the container
						survived.style.position = "relative";
						survived.style.top = originalDottedLineHeight / 16 + "rem";
					}
				}
			}
		};

		const chartLabels = {
			firstChart: {
				outperformed: firstLabel.current,
				survived: secondLabel.current
			},
			secondChart: {
				outperformed: secondChartFirstLabel.current,
				survived: secondChartSecondLabel.current
			},
			thirdChart: {
				outperformed: thirdChartFirstLabel.current,
				survived: thirdChartSecondLabel.current
			},
			fourthChart: {
				outperformed: fourthChartFirstLabel.current,
				survived: fourthChartSecondLabel.current
			}
		};

		if (labelsReadyToMove) {
			fixCollidingLabels(chartLabels);
			setLabelsReadyToMove(false);
		}
	}, [labelsReadyToMove, isMobileScreen]);

	return (
		<DimensionalDifferenceTwoColumnContainer choiceNumber={3}>
			<AnimatedExhibitInfographicHeadline headline={infographicHeadline} />
			<div className="ddiff-outperformed-container" ref={chartSection}>
				<div className="ddiff-outperformed-charts">
					<div
						onAnimationStart={triggerFirstChartAnimation}
						className={
							headlineAnimation
								? "ddiff-outperformed-charts-title t-label-sm-heavy tc-cool-gray-01 animate-headline"
								: "ddiff-outperformed-charts-title t-label-sm-heavy tc-cool-gray-01"
						}
					>
						{headline}
					</div>

					<div
						className={
							chartOpacity
								? "ddiff-outperformed-chart animate-chart-color"
								: "ddiff-outperformed-chart"
						}
					>
						<div
							className={
								chartOpacity
									? "ddiff-outperformed-chart-year animate-section-year t-body-md-heavy tc-cool-gray-02"
									: "ddiff-outperformed-chart-year t-body-md-heavy tc-cool-gray-02"
							}
						>
							{charts[0].years}
						</div>
						<div className="ddiff-outperformed-chart-container first-chart">
							<div className="ddiff-outperformed-chart-graph">
								<div
									className={
										chartOpacity
											? "ddiff-outperformed-chart-text animate-section-title t-body-sm tc-cool-gray-01"
											: "ddiff-outperformed-chart-text t-body-sm tc-cool-gray-01"
									}
								>
									{charts[0].stocks[0].stockTitle}
								</div>

								<div className="ddiff-outperformed-chart-graphs">
									<div
										className={
											chartOpacity
												? "ddiff-outperformed-chart-graph-bar animate-chart-width"
												: "ddiff-outperformed-chart-graph-bar"
										}
									></div>
									<div
										className={
											colorChartOpacity
												? "ddiff-outperformed-chart-graph-color teal animate-color"
												: "ddiff-outperformed-chart-graph-color teal"
										}
										style={{ width: colorWidth.chartOne.itemOne.width }}
									></div>
									<div
										ref={coloredChart}
										className={
											firstDotsRun
												? "ddiff-outperformed-chart-graph-lines animate-line-one"
												: "ddiff-outperformed-chart-graph-lines"
										}
										style={{
											left: firstDotsRun
												? colorWidth.chartOne.itemOne.left
												: colorWidth.chartOne.itemTwo.left
										}}
									>
										<div className="ddiff-outperformed-chart-graph-dots-one">
											<VerticalLine />
										</div>

										<div
											className={
												firstDotsRun
													? "ddiff-outperformed-chart-graph-labels animate-numbers-one"
													: "ddiff-outperformed-chart-graph-labels"
											}
											style={{ left: colorWidth.chartOne.itemOne.left, marginLeft: firstLabelpos }}
											ref={firstLabel}
										>
											<div className="ddiff-outperformed-chart-graph-labels-numbers t-heading-md">
												{charts[0].stocks[0].stockValues[0].value}
											</div>
											<div className="ddiff-outperformed-chart-graph-labels-text t-label-xxs">
												{charts[0].stocks[0].stockValues[0].item}
											</div>
										</div>
									</div>
									<div
										ref={secondDots}
										className={
											bgChartWidth
												? "ddiff-outperformed-chart-graph-lines animate-line-two"
												: "ddiff-outperformed-chart-graph-lines"
										}
										style={{ left: colorWidth.chartOne.itemTwo.left }}
									>
										<div className={"ddiff-outperformed-chart-graph-dots-two"}>
											<VerticalLine />
										</div>
										<div
											className={
												bgChartWidth
													? "ddiff-outperformed-chart-graph-labels animate-numbers-two"
													: "ddiff-outperformed-chart-graph-labels"
											}
											style={{ marginLeft: secondLabelpos }}
											onAnimationEnd={triggerFirstDots}
											ref={secondLabel}
										>
											<div className="ddiff-outperformed-chart-graph-labels-numbers survived-number t-label-sm tc-cool-gray-01">
												{charts[0].stocks[0].stockValues[1].value}
											</div>
											<div className="ddiff-outperformed-chart-graph-labels-text t-label-xxs tc-cool-gray-02">
												{charts[0].stocks[0].stockValues[1].item}
											</div>
										</div>
									</div>
								</div>

								<div className="ddiff-outperformed-chart-graph-container"></div>
							</div>

							<div className="ddiff-outperformed-chart-graph ddiff-outperformed-chart-graph-second">
								<div
									className={
										chartOpacity
											? "ddiff-outperformed-chart-text animate-section-title t-body-sm tc-cool-gray-01"
											: "ddiff-outperformed-chart-text t-body-sm tc-cool-gray-01"
									}
								>
									{charts[0].stocks[1].stockTitle}
								</div>
								<div className="ddiff-outperformed-chart-graphs">
									<div
										className={
											chartOpacity
												? "ddiff-outperformed-chart-graph-bar animate-chart-width"
												: "ddiff-outperformed-chart-graph-bar"
										}
									></div>
									<div
										className={
											colorChartOpacity
												? "ddiff-outperformed-chart-graph-color yellow animate-color"
												: "ddiff-outperformed-chart-graph-color yellow"
										}
										style={{ width: colorWidth.chartTwo.itemOne.width }}
									></div>
									<div
										className={
											firstDotsRun
												? "ddiff-outperformed-chart-graph-lines animate-line-one"
												: "ddiff-outperformed-chart-graph-lines"
										}
										style={{
											left: firstDotsRun
												? colorWidth.chartTwo.itemOne.left
												: colorWidth.chartTwo.itemTwo.left
										}}
									>
										<div
											className="ddiff-outperformed-chart-graph-dots-one animate-dots-one"
											style={{
												left: colorWidth.chartTwo.itemOne.left
											}}
										>
											<VerticalLine />
										</div>
										<div
											className={
												firstDotsRun
													? "ddiff-outperformed-chart-graph-labels animate-numbers-one"
													: "ddiff-outperformed-chart-graph-labels"
											}
											style={{ marginLeft: firstLabelpos, left: "4rem" }}
											ref={secondChartFirstLabel}
											onAnimationStart={() => {
												setLabelsReadyToMove(true);
											}}
										>
											<div className="ddiff-outperformed-chart-graph-labels-numbers t-heading-md">
												{charts[0].stocks[1].stockValues[0].value}
											</div>
											<div className="ddiff-outperformed-chart-graph-labels-text t-label-xxs">
												{charts[0].stocks[1].stockValues[0].item}
											</div>
										</div>
									</div>
									<div
										className={
											bgChartWidth
												? "ddiff-outperformed-chart-graph-lines animate-line-two"
												: "ddiff-outperformed-chart-graph-lines"
										}
										style={{ left: colorWidth.chartTwo.itemTwo.left }}
									>
										<div
											className={"ddiff-outperformed-chart-graph-dots-two"}
											style={{ left: colorWidth.chartOne.itemTwo.left }}
										>
											<VerticalLine />
										</div>

										<div
											className={
												bgChartWidth
													? "ddiff-outperformed-chart-graph-labels animate-numbers-two"
													: "ddiff-outperformed-chart-graph-labels"
											}
											style={{ marginLeft: secondLabelpos }}
											ref={secondChartSecondLabel}
										>
											<div className="ddiff-outperformed-chart-graph-labels-numbers survived-number t-label-sm tc-cool-gray-01">
												{charts[0].stocks[1].stockValues[1].value}
											</div>
											<div className="ddiff-outperformed-chart-graph-labels-text t-label-xxs tc-cool-gray-02">
												{charts[0].stocks[1].stockValues[1].item}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div
						className={
							secondChart
								? "ddiff-outperformed-chart second-chart-show"
								: "ddiff-outperformed-chart second-chart-hide"
						}
					>
						<div className="ddiff-outperformed-chart-year t-body-md-heavy tc-cool-gray-02">
							{charts[1].years}
						</div>
						<div className="ddiff-outperformed-chart-container">
							<div className="ddiff-outperformed-chart-graph">
								<div className="ddiff-outperformed-chart-text t-body-sm tc-cool-gray-01">
									{charts[1].stocks[0].stockTitle}
								</div>
								<div className="ddiff-outperformed-chart-graphs">
									<div className="ddiff-outperformed-chart-graph-bar second-chart"></div>
									<div
										className="ddiff-outperformed-chart-graph-color static-chart teal"
										style={{ width: colorWidth.chartThree.itemOne.width }}
									></div>
									<div
										className="ddiff-outperformed-chart-graph-lines static-lines-first"
										style={{ left: colorWidth.chartThree.itemOne.left }}
									>
										<div className="ddiff-outperformed-chart-graph-lines static-dots-first">
											<VerticalLine />
										</div>
										<div
											className={"ddiff-outperformed-chart-graph-labels animate-numbers"}
											style={{ marginLeft: firstLabelpos }}
											ref={thirdChartFirstLabel}
										>
											<div className="ddiff-outperformed-chart-graph-labels-numbers t-heading-md">
												{charts[1].stocks[0].stockValues[0].value}
											</div>
											<div className="ddiff-outperformed-chart-graph-labels-text t-label-xxs">
												{charts[1].stocks[0].stockValues[0].item}
											</div>
										</div>
									</div>
									<div
										className="ddiff-outperformed-chart-graph-lines static-lines-second"
										style={{ left: colorWidth.chartThree.itemTwo.left }}
									>
										<div className="ddiff-outperformed-chart-graph-lines static-dots-second">
											<VerticalLine />
										</div>
										<div
											className={"ddiff-outperformed-chart-graph-labels animate-numbers"}
											style={{ marginLeft: secondLabelpos }}
											ref={thirdChartSecondLabel}
										>
											<div className="ddiff-outperformed-chart-graph-labels-numbers survived-number t-label-sm tc-cool-gray-01">
												{charts[1].stocks[0].stockValues[1].value}
											</div>
											<div className="ddiff-outperformed-chart-graph-labels-text t-label-xxs tc-cool-gray-02">
												{charts[1].stocks[0].stockValues[1].item}
											</div>
										</div>
									</div>
								</div>
								<div className="ddiff-outperformed-chart-graph-container"></div>
							</div>

							<div className="ddiff-outperformed-chart-graph ddiff-outperformed-chart-graph-second">
								<div className="ddiff-outperformed-chart-text t-body-sm tc-cool-gray-01">
									{charts[1].stocks[1].stockTitle}
								</div>
								<div className="ddiff-outperformed-chart-graphs">
									<div className="ddiff-outperformed-chart-graph-bar second-chart"></div>
									<div
										className="ddiff-outperformed-chart-graph-color static-chart yellow"
										style={{ width: colorWidth.chartFour.itemOne.width }}
									></div>
									<div
										className="ddiff-outperformed-chart-graph-lines static-lines-first"
										style={{ left: colorWidth.chartFour.itemOne.left }}
									>
										<div className="ddiff-outperformed-chart-graph-lines static-dots-first">
											<VerticalLine />
										</div>
										<div
											className={"ddiff-outperformed-chart-graph-labels animate-numbers"}
											style={{ marginLeft: firstLabelpos }}
											ref={fourthChartFirstLabel}
										>
											<div className="ddiff-outperformed-chart-graph-labels-numbers t-heading-md">
												{charts[1].stocks[1].stockValues[0].value}
											</div>
											<div className="ddiff-outperformed-chart-graph-labels-text t-label-xxs">
												{charts[1].stocks[1].stockValues[0].item}
											</div>
										</div>
									</div>
									<div
										className="ddiff-outperformed-chart-graph-lines static-lines-second"
										style={{ left: colorWidth.chartFour.itemTwo.left }}
									>
										<div className="ddiff-outperformed-chart-graph-lines static-dots-second">
											<VerticalLine />
										</div>
										<div
											className={"ddiff-outperformed-chart-graph-labels animate-numbers"}
											style={{ marginLeft: secondLabelpos }}
											ref={fourthChartSecondLabel}
										>
											<div className="ddiff-outperformed-chart-graph-labels-numbers survived-number t-label-sm tc-cool-gray-01">
												{charts[1].stocks[1].stockValues[1].value}
											</div>
											<div className="ddiff-outperformed-chart-graph-labels-text t-label-xxs tc-cool-gray-02">
												{charts[1].stocks[1].stockValues[1].item}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					{headlineAnimation && (
						<>
							{disclosure && (
								<div
									className="ddiff-outperformed-disclosures-show t-body-md-heavy"
									dangerouslySetInnerHTML={{ __html: getDecodedHtml(disclosure) }}
								></div>
							)}
							{hoverContent && (
								<div className="ddiff-outperformed-little-i-show">
									<DToolTipAdapterContainer content={hoverContent} align="right" />
								</div>
							)}
						</>
					)}
				</div>
			</div>
		</DimensionalDifferenceTwoColumnContainer>
	);
};

export default OutperformedAnimatedExhibit;
